import ServiceCRUD from '../../../../../../services/ServiceCRUDCHATTS';

class ConversationExportService extends ServiceCRUD {
  constructor() {
    super('relatorio');
  }
}

export default new ConversationExportService();
